import React, { Component } from 'react';

var __html = require("../html/blog_1.js");
var template = { __html: __html };

export default class BlogLeetcodeValidParentheses extends Component {
  render() {
    return (
      <div dangerouslySetInnerHTML={template} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/blog/BlogLeetcodeValidParentheses.jsx